import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function listSortingReducer(state = initialstate.dynamicList.sortingProps, action) {
	switch (action.type) {
		case types.UPDATE_SORTING_PROPS:
			return action.payload;
		case types.CLEAR_SORTING_PROPS:
			return {}
		default:
			return state;
	}
}
